module.exports = __webpack_public_path__ + "media/逆转糖尿病小.8d25c729.mp4";